import { BCDataGrid, BCTreeList } from '@bimser/components';
import DataGrid2 from '../..';
import { IInitNewRowEventArgs } from '../../../../entities/EventArgs';
import { IComboBoxProperties } from '../../../ComboBox/entities/IComboBoxProperties';
import { IDataGridColumn, IDataGridRowCollection } from '../../entities';

export function onInitNewRow(
	this: DataGrid2,
	e:
		| BCDataGrid.Entities.DataGridTypes.InitNewRowEvent
		| BCTreeList.Components.TreeListTypes.InitNewRowEvent
) {
	this.pendingEdit = true;

	this.__isNewRowEditing = true;

	if (this.saveMode == 'self' && !this.__form.documentId) {
		this.__form.saveForm(true);
	}

	setDefaults.call(this, e);

	const primaryColumn = this.columns.find(column => column.isPrimaryKey);

	if (primaryColumn.autoIncrement) {
		e.data[primaryColumn.name] = highestPrimary(primaryColumn.name, [...this.rows]) + 1;
	}

	e.promise = new Promise(async res => {
		const valueArgs: IInitNewRowEventArgs = { data: e.data };

		await this.emit('event:OnInitNewRow', valueArgs);

		Object.entries(valueArgs.data).forEach(([column, value]) => {
			e.data[column] = value;
		});

		res();
	});
}

function setDefaults(
	this: DataGrid2,
	e:
		| BCDataGrid.Entities.DataGridTypes.InitNewRowEvent
		| BCTreeList.Components.TreeListTypes.InitNewRowEvent
) {
	const checkBoxColumns = this.columns.filter(column => column.editType === 'checkBox');

	checkBoxColumns.forEach(checkBoxColumn => {
		e.data[checkBoxColumn.name] = checkBoxColumn.defaultValue;
	});

	const comboBoxColumns = this.columns.filter(column => column.editType === 'comboBox');

	comboBoxColumns.forEach((comboBoxColumn: IDataGridColumn<IComboBoxProperties>) => {
		if (comboBoxColumn.editControl.dataSourceType === 'static') {
			const selected = comboBoxColumn.editControl.items.find(item => item.selected);

			if (selected) {
				if (comboBoxColumn.dbType.type === 'object') {
					e.data[comboBoxColumn.name] = selected;
				} else {
					e.data[comboBoxColumn.name] = selected.value;
				}
			}
		}
	});
}

export const highestPrimary = (keyExpr: string, rows: IDataGridRowCollection) => {
	return (
		Number(
			rows.sort((a, b) => Number(b.data[keyExpr] || 0) - Number(a.data[keyExpr] || 0)).at(0)
				?.data[keyExpr] || 0
		) || 0
	);
};
